if (!customElements.get('product-modal')) {
  customElements.define(
    'product-modal',
    class ProductModal extends ModalDialog {
      constructor() {
        super();
        this.openedBy = null;
      }

      show(opener) {
        this.openedBy = opener || this.openedBy;
        super.show(opener);

        this.initModalMedia();
        this.setupArrows();
      }

      initModalMedia() {
        const mediaItems = Array.from(
          this.querySelectorAll('.product-media-modal__content [data-media-id]')
        );

        if (!mediaItems.length) return;

        const targetId = this.openedBy?.getAttribute('data-media-id');

        mediaItems.forEach((item) => {
          item.style.display = 'none';
          item.classList.remove('is-active');
          item.classList.remove('active');
        });

        let activeItem = mediaItems.find(
          (item) => item.getAttribute('data-media-id') === targetId
        );

        if (!activeItem) activeItem = mediaItems[0];

        activeItem.style.display = 'block';
        activeItem.classList.add('is-active');
        activeItem.classList.add('active');

        this.currentIndex = mediaItems.indexOf(activeItem);
        this.mediaItems = mediaItems;
      }

      setupArrows() {
        this.querySelectorAll('.modal-arrow').forEach((b) => b.remove());

        if (!this.mediaItems || this.mediaItems.length <= 1) return;

        const dialog = this.querySelector('.product-media-modal__dialog');
        if (!dialog) return;

        const prev = document.createElement('button');
        const next = document.createElement('button');

        prev.className = 'modal-arrow modal-arrow--prev';
        next.className = 'modal-arrow modal-arrow--next';

        prev.innerHTML = '‹';
        next.innerHTML = '›';

        const stop = (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
        };

        prev.addEventListener('click', (e) => {
          stop(e);
          this.move(-1);
        });

        next.addEventListener('click', (e) => {
          stop(e);
          this.move(1);
        });

        dialog.appendChild(prev);
        dialog.appendChild(next);

        dialog.addEventListener('click', (e) => {
          e.stopPropagation();
        });
      }

      move(dir) {
        if (!this.mediaItems || !this.mediaItems.length) return;

        this.currentIndex =
          (this.currentIndex + dir + this.mediaItems.length) %
          this.mediaItems.length;

        this.mediaItems.forEach((item) => {
          item.style.display = 'none';
          item.classList.remove('is-active');
          item.classList.remove('active');
        });

        const active = this.mediaItems[this.currentIndex];

        active.style.display = 'block';
        active.classList.add('is-active');
        active.classList.add('active');
      }
    }
  );
}